import { ShieldCheck, Award, Lock, TrendingUp, Building2, BadgeCheck, Sparkles, FileCheck2 } from "lucide-react";

const ICON_MAP = {
  shield: ShieldCheck,
  award: Award,
  lock: Lock,
  trending: TrendingUp,
  building: Building2,
  badge: BadgeCheck,
  sparkles: Sparkles,
  document: FileCheck2,
};

const DEFAULT_ITEMS = [
  { icon: "shield", label: "Estructura AEP formal" },
  { icon: "lock", label: "Proceso confidencial" },
  { icon: "document", label: "Contratos auditados" },
  { icon: "building", label: "8 años operando" },
  { icon: "award", label: "36 sucursales activas" },
  { icon: "trending", label: "+50% margen histórico" },
  { icon: "badge", label: "Distribución mensual" },
  { icon: "sparkles", label: "Marca establecida en México" },
];

export default function TrustSignalsMarquee({ block }) {
  if (block?.visible === false) return null;
  const items = block?.items?.length ? block.items : DEFAULT_ITEMS;
  const loop = [...items, ...items];

  return (
    <section
      aria-label="Señales de confianza"
      className="relative overflow-hidden py-5 border-y border-white/[0.06] bg-[#0A0A0A]"
      data-testid="trust-marquee"
    >
      {/* Subtle top/bottom hairlines */}
      <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#FFBF57]/25 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-[#FFBF57]/15 to-transparent" />

      {/* Fade edges — fade from solid black */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0A0A0A] via-[#0A0A0A]/85 to-transparent z-10 pointer-events-none" />

      <div className="marquee-track">
        {loop.map((it, i) => {
          const Ic = ICON_MAP[it.icon] || ShieldCheck;
          return (
            <div
              key={i}
              className="group flex items-center gap-2.5 shrink-0"
              data-testid={`trust-item-${i}`}
            >
              <Ic size={14} className="text-[#FFBF57] transition-transform duration-500 group-hover:scale-110" strokeWidth={1.6} />
              <span className="font-mono text-[11px] uppercase tracking-[0.22em] text-white/85 group-hover:text-white transition-colors">
                {it.label}
              </span>
              <span className="text-[#FFBF57]/40 mx-4 select-none">·</span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
